"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendars = void 0;
const gearbox_1 = require("@busy-human/gearbox");
const Events_1 = require("../Events");
// This will likely need to be moved into the independent calendar module, whenever that gets made
var Calendars;
(function (Calendars) {
    Calendars.Relationships = {
        events: ["events", Events_1.Events.CollectionClass]
    };
    class CollectionClass extends gearbox_1.CollectionEntity {
        defaults() {
            return {
                type: 'google',
                refreshToken: '',
                stateToken: null,
                accessToken: '',
            };
        }
    }
    Calendars.CollectionClass = CollectionClass;
    function DefaultGoogle() {
        return {
            type: 'google',
            refreshToken: '',
            stateToken: null,
            accessToken: ''
        };
    }
    Calendars.DefaultGoogle = DefaultGoogle;
    function DefaultMicrosoft() {
        return {
            type: 'microsoft',
            refreshToken: '',
            stateToken: null,
            accessToken: ''
        };
    }
    Calendars.DefaultMicrosoft = DefaultMicrosoft;
})(Calendars = exports.Calendars || (exports.Calendars = {}));
//# sourceMappingURL=index.js.map